<template>
  <img
    src="https://static.wangsu.com/lib/images/status/v1/upgrade.min.svg"
    alt="upgrade"
  />
</template>
<script setup lang="ts">
import { defineComponent } from 'vue'

defineComponent({
  name: 'ElResultIconUpgrade',
})
</script>
